import { render, staticRenderFns } from "./SalaryEffectEdit.vue?vue&type=template&id=da553550&scoped=true&"
import script from "./SalaryEffectEdit.vue?vue&type=script&lang=js&"
export * from "./SalaryEffectEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da553550",
  null
  
)

export default component.exports